export default {
      id: "kazakh_tourism-usage",
      viewBox: "0 0 56 44",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#kazakh_tourism",
      toString: function () {
        return this.url;
      }
    }